import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Formik, useField, useFormikContext } from "formik";
import * as Yup from "yup";
import { Autocomplete, Button, createStyles, FormHelperText, Input, InputLabel } from "@mui/material";
import { EDialogAction } from "../Enum/DialogActionEnum";
import DatePicker from "react-datepicker";
import TextField from "@mui/material/TextField";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";
import { CountryCodeDisplayEnum, CountryCodeEnum } from "../../Types/Enum";

const useStyles = makeStyles((theme) => ({
  disabled: {
    "& input:disabled": {
      color: "red",
    },
  },
}));

export const DatePickerField = ({
  ...props
}: {
  [x: string]: any;
  name: string;
}) => {
  const { setFieldValue } = useFormikContext();
  const [disabled, setDisabled] = useState(true);
  const [field] = useField(props);

  return (
    <DatePicker
      {...field}
      {...props}
      placeholderText={"Please select a date"}
      readOnly={props.dialogAction == EDialogAction.view}
      selected={(field.value && new Date(field.value)) || null}
      dateFormat="yyyy-MM-dd"
      onChange={(val) => {
        setFieldValue(field.name, val?.toISOString().split("T")[0]);
      }}
    />
  );
};

const CountryProcessDialogBox = (props: {
  open: boolean;
  onClose: any;
  data: any;
  dialogAction: EDialogAction;
}) => {
  const limit = 10;

  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const theme = useTheme();
  const classes = useStyles();
  const formik = useFormikContext();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [type, setType] = useState("dom");
  const [countryProcess, setCountryProcess] = useState(props.data);
  const [jobTitleList, setJobTitleList] = useState<any[]>([]);
  const [jobTitleListForOther, setJobTitleListForOther] = useState<any[]>([]);

  const formRef = useRef<any>();

  useEffect(() => {
    setCountryProcess(props.data);
  }, [props.data]);

  useEffect(() => {
    getJobTitleList();
  }, [type]);

  const handleClose = (action: string = "closed") => {
    props.onClose(action);
  };

  const createCountryProcess = async (data: any) => {
    try {
      const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process`;

      const res = await axiosInstance.post(url, {
        country_name: data.country_name,
        country_code: data.country_code,
        title: data.title,
        status: data.status,
        type: data.type,
        start_date: data.start_date,
        end_date: data.end_date,
      });
      enqueueSnackbar("Country Process Created Successfully!!!", {
        variant: "success",
      });
      handleClose("created");
    } catch (err: any) {
      enqueueSnackbar(
        `Country Process Creation Unsuccessful!!! ${err.response.data.error}`,
        {
          variant: "error",
        }
      );
      console.error(err);
    }
  };
  const editCountryProcess = async (data: any) => {
    const url = `${process.env.REACT_APP_API_ORIGIN}/v1/country-process/${countryProcess.id}`;

    axiosInstance
      .put(url, {
        country_name: data.country_name,
        country_code: data.country_code,
        title: data.title,
        status: data.status,
        type: data.type,
        start_date: data.start_date,
        end_date: data.end_date,
      })
      .then((response) => {
        
      })
      .catch((err: any) => {
        enqueueSnackbar(
          `Country Process Updation Unsuccessfull!!! ${err.response.data.error}`,
          {
            variant: "error",
          }
        );
      });
    enqueueSnackbar("Country Process Updated Successfully!!!", {
      variant: "success",
    });

    handleClose();
  };

  const handleJobListChange = async (inputValue: any, source: any) => {

    try {
      const response = await axiosInstance.get(
        `/v1/job-titles?type=${theme.theme}&page=${page}&items_per_page=${limit}&keyword=${inputValue}`,
        {}
      );
      const data = response.data;

      // Update the relevant state based on the source
      if (source === 'jobTitleOther') {
        // Set the state specific to the first Autocomplete
        setJobTitleListForOther(data.result.data);
      } else if (source === 'jobList') {
        // Set the state specific to the second Autocomplete
        setJobTitleList(data.result.data);
      }
    } catch (error) {
      console.error('Error fetching job titles:', error);
    }
  };

  const getJobTitleList = async () => {
    try {
      const response = await axiosInstance.get(
        `/v1/job-titles?type=${theme.theme}&page=${page}&items_per_page=${limit}`,
        {}
      );

      const data = response.data;
      setJobTitleList(data.result.data);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {" "}
      {countryProcess == null ? (
        <div></div>
      ) : (
        <Dialog
          open={props.open}
          onClose={(event, reason) => {
            if (reason != "backdropClick" && reason != "escapeKeyDown") {
              handleClose();
            }
          }}
        >
          {props.dialogAction == EDialogAction.edit ? (
            <DialogTitle>Edit Country Process :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.create ? (
            <DialogTitle>Create Country Process </DialogTitle>
          ) : (
            <></>
          )}
          {props.dialogAction == EDialogAction.view ? (
            <DialogTitle>View Country Process :{props.data.id}</DialogTitle>
          ) : (
            <></>
          )}
          <DialogContent>
            <Formik
              enableReinitialize
              validateOnMount
              initialValues={
                props.dialogAction == EDialogAction.create
                  ? {
                    id: +"",
                    country_name: "",
                    country_code: "",
                    title: "",
                    status: "enb",
                    type: "dom",
                    start_date: new Date().toISOString().split("T")[0],
                    end_date: "",
                  }
                  : countryProcess
              }
              initialTouched={{ zip: true }}
              validationSchema={Yup.object().shape({
                country_name: Yup.string()
                  .required("Country Name is Required")
                  .max(
                    65,
                    "Country Name must not be greater than 65 characters"
                  ),

                country_code: Yup.string()
                  .max(8, "Country Code must not be greater than 08 characters")
                  .required("Country Code is Required"),
                title: Yup.string()
                  .max(150, "Title must not be greater than 150 characters")
                  .required("Title is Required"),
                status: Yup.string().required("Status is Required"),
                type: Yup.string().required("Type is Required"),
                start_date: Yup.string().required("Start Date is Required"),
              })}
              onSubmit={
                props.dialogAction == EDialogAction.create
                  ? createCountryProcess
                  : editCountryProcess
              }
              innerRef={formRef}
            >
              {({
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                values,
                touched,
                errors,
              }) => (
                <div className="grid grid-cols-2 mt-4">
                  <div className="flex flex-col space-y-1 mr-6 mb-4">

                    <TextField
                      disabled={props.dialogAction == EDialogAction.view}
                      id="country_name"
                      required
                      label="Country Name"
                      variant="outlined"
                      onChange={handleChange}
                      value={values.country_name}
                      placeholder="Enter Country Name"
                      name="country_name"
                      error={Boolean(
                        errors.country_name && touched.country_name
                      )}
                      helperText={
                        errors.country_name &&
                        touched.country_name &&
                        String(errors.country_name)
                      }
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div>
                      <FormControl>
                        <InputLabel id="status-select-standard-label" required>Status</InputLabel>
                        <Select
                          disabled={props.dialogAction == EDialogAction.view}
                          style={{ width: 245, }}
                          id="status"
                          labelId="status-select-standard-label"
                          label="Status"
                          required
                          defaultValue=""
                          value={values.status}
                          onChange={handleChange}
                          name="status"
                          error={Boolean(touched.status && errors.status)}
                        >
                          <MenuItem value={""}>
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={"enb"}>Enabled</MenuItem>
                          <MenuItem value={"dis"}>Disabled</MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText style={{ color: "red" }}>
                        {errors.status &&
                          touched.status &&
                          String(errors.status)}
                      </FormHelperText>
                    </div>
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div>
                      <FormControl>
                        <InputLabel id="type-select-standard-label" required>Type</InputLabel>
                        <Select
                          disabled={props.dialogAction == EDialogAction.view}
                          style={{ width: 245 }}
                          id="type"
                          labelId="type-select-standard-label"
                          label="Type"
                          defaultValue=""
                          value={values.type}
                          // onChange={handleChange}
                          onChange={(e) => {
                            setFieldValue("type", e.target.value);
                            setType(e.target.value);
                          }}
                          name="type"
                          error={Boolean(touched.type && errors.type)}
                        >
                          <MenuItem value={"dom"}>Domestic</MenuItem>
                          <MenuItem value={"corp"}>Corporate</MenuItem>
                        </Select>
                      </FormControl>
                      <FormHelperText style={{ color: "red" }}>
                        {errors.type && touched.type && String(errors.type)}
                      </FormHelperText>
                    </div>
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div className=" ">
                      <label className="text-sm">Start Date</label>
                      <label className="text-red-700">*</label>
                    </div>
                    <label className="flex inline-block ">
                      <DatePickerField name="start_date" />
                      <CalendarMonthIcon />
                    </label>
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4">

                    <Autocomplete
                      value={values.country_code ? values.country_code : null}
                      disabled={props.dialogAction == EDialogAction.view}
                      disablePortal
                      id="combo-box-demo"
                      options={Object.values(CountryCodeEnum)}
                      getOptionLabel={(option) =>
                        CountryCodeDisplayEnum[option]
                      }
                      onChange={(e, value) =>
                        setFieldValue("country_code", value)
                      }
                      sx={{ width: 245, maxHeight: "1em" }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="country_code"
                          label="Country Code"
                          disabled={props.dialogAction == EDialogAction.view}
                          onChange={handleChange}
                          value={values.country_code}
                          placeholder={
                            values == ""
                              ? "Enter Country Code"
                              : CountryCodeDisplayEnum[
                              countryProcess.country_code
                              ]
                          }
                          error={Boolean(
                            touched.country_code && errors.country_code
                          )}
                          helperText={
                            errors.country_code &&
                            touched.country_code &&
                            String(errors.country_code)
                          }
                        />
                      )}
                    />
                  </div>
                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <div className=" ">
                      <label className="text-sm">End Date</label>
                    </div>
                    <label className="flex inline-block ">
                      <DatePickerField name="end_date" />
                      <CalendarMonthIcon />
                    </label>
                  </div>

                  <div className="flex flex-col space-y-1 mr-6 mb-4">
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={jobTitleList}
                      value={jobTitleList.find(option => option.title === values.title) || null}
                      disabled={props.dialogAction == EDialogAction.view}
                      getOptionLabel={(option) => option.title}
                      onChange={(e, value) =>
                        setFieldValue("title", value ? value.title : "")
                      }
                      onOpen={() => handleJobListChange(" ", 'jobList')} // Handle open event
                      onInputChange={(event, value) => handleJobListChange(value, 'jobList')}
                      isOptionEqualToValue={(option, value) => option.title === value.title}
                      sx={{ width: 245, }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="title"
                          label="Job Title"
                          required
                          value={values.title}
                          onChange={handleChange}
                          placeholder={
                            values == "" ? "Enter Title" : countryProcess.title
                          }
                          error={Boolean(touched.title && errors.title)}
                          helperText={
                            errors.title &&
                            touched.title &&
                            String(errors.title)
                          }
                        />
                      )}
                    />
                  </div>
                  <div>
                    <div className="flex py-3 px-3 space-x-4 justify-center">
                      {props.dialogAction != EDialogAction.view ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          {props.dialogAction == EDialogAction.edit ? "Update " : "Create"}
                        </Button>
                      ) : null}
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CountryProcessDialogBox;
